import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@material-ui/core';

import { BillingOptionType, FrequencyTypes } from 'modules/services/constants/packages';

import { IEditablePackageConfiguration } from 'common/interfaces/membership';
import { IBillingOption } from 'modules/services/interfaces/packages';

import { FieldInfo } from 'common/components/index';

import servicesMessages from 'modules/services/messages/messages';
import inputLabels from 'common/messages/inputLabels';
import { formatPrice } from 'common/utils';

interface IProps {
  membershipPackage: IEditablePackageConfiguration;
  billingOption: IBillingOption;
  isOutOfTerm: boolean;
}

const AmountSectionView = ({
  billingOption,
  membershipPackage,
  isOutOfTerm,
}: IProps): JSX.Element => {
  const { type: optionType } = billingOption;

  const {
    paymentEditableSchedule: paymentEditableSchedulePachege,
    totalAmount,
  } = membershipPackage;

  const paymentEditableSchedule = isOutOfTerm
    ? membershipPackage.outOfTermBillingOption?.paymentEditableSchedule
    : paymentEditableSchedulePachege;

  const taxedTotalAmount = isOutOfTerm
    ? membershipPackage.outOfTermBillingOption?.taxedTotalAmount
    : membershipPackage.taxedTotalAmount;

  const pricePerBilling = isOutOfTerm
    ? membershipPackage.outOfTermBillingOption?.pricePerBilling
    : membershipPackage.pricePerBilling;

  return (
    <>
      <Grid item xs={4}>
        <FieldInfo
          label={<FormattedMessage {...inputLabels.totalAmount} />}
          description={formatPrice(
            (isOutOfTerm
              ? membershipPackage.outOfTermBillingOption?.totalAmount?.value
              : totalAmount?.value) || 0,
          )}
        />
      </Grid>

      <Grid item xs={4}>
        <FieldInfo
          label={<FormattedMessage {...inputLabels.taxedTotalAmount} />}
          description={formatPrice(taxedTotalAmount || 0)}
        />
      </Grid>

      {optionType !== BillingOptionType.PAID_IN_FULL && (
        <>
          <Grid item xs={4}>
            <FieldInfo
              label={<FormattedMessage {...servicesMessages.paymentScheduleLabel} />}
              description={FrequencyTypes.translate(paymentEditableSchedule?.value || '')}
            />
          </Grid>

          <Grid item xs={4}>
            <FieldInfo
              label={<FormattedMessage {...servicesMessages.pricePerBillingLabel} />}
              description={formatPrice(pricePerBilling || '')}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default AmountSectionView;
